import React, { useRef, useState } from 'react';
import { Typography } from '@mui/material';

import { CloseButton, Dialog, DialogActions, DialogContent, DialogTitle, SubmitButton } from 'components';
import { ZoneCategoryForm } from 'forms';

interface ZoneCategoryCreateDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  title?: string;
  submitButtonLabel?: string;
}

export const ZoneCategoryCreateDialog = ({
  visible = false,
  setVisible = () => {},
  title = 'Create Zone Category',
  submitButtonLabel = 'Create',
}: ZoneCategoryCreateDialogProps) => {
  const formRef = useRef<any>();
  const [loading, setLoading] = useState<boolean>(false);

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog open={visible} onClose={onClose} PaperProps={{ sx: { overflow: 'visible' } }}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <ZoneCategoryForm
          ref={formRef}
          onSubmitting={(loading) => setLoading(loading)}
          next={() => {
            onClose(null, 'anyway');
          }}
        />
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading} label={submitButtonLabel} onClick={onSubmit} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
